import { render } from "./dms.vue?vue&type=template&id=46b1ece0&scoped=true"
import script from "./dms.vue?vue&type=script&lang=js"
export * from "./dms.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./dms.vue?vue&type=style&index=1&id=46b1ece0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b1ece0"]])

export default __exports__